import { AtSign, Paperclip, Type, CircleDot, CalendarDays, Send } from "lucide-react";

const HINTS = [
  { op: "from:", example: "from:ralph", desc: "Sent by a name or email", icon: AtSign },
  { op: "to:", example: "to:acme.com", desc: "Sent to an address or domain", icon: Send },
  { op: "subject:", example: "subject:invoice", desc: "Words in the subject", icon: Type },
  { op: "has:attachment", example: "has:attachment", desc: "Has files attached", icon: Paperclip },
  { op: "is:unread", example: "is:unread", desc: "Also is:open, is:pending, is:closed", icon: CircleDot },
  { op: "after:", example: "after:2026-05-01", desc: "On or after a date · before: works too", icon: CalendarDays },
];

// Clickable filter cheat-sheet shown under the empty/focused search box.
export function SearchHints({ onPick }) {
  return (
    <div
      className="absolute left-0 right-0 top-full mt-2 z-40 bg-white border border-zinc-200 rounded-2xl shadow-lg p-2 animate-in fade-in slide-in-from-top-1 duration-150"
      data-testid="search-hints"
      onMouseDown={(e) => e.preventDefault()}
    >
      <div className="px-2 pt-1 pb-2 text-[11px] uppercase tracking-wider text-zinc-400 font-medium">
        Narrow your search
      </div>
      {HINTS.map(({ op, example, desc, icon: Icon }) => (
        <button
          key={op}
          type="button"
          onClick={() => onPick(op.endsWith(":") ? op : `${op} `)}
          className="w-full flex items-start sm:items-center gap-3 px-2 py-2 rounded-xl text-left hover:bg-zinc-100 transition-colors"
          data-testid={`search-hint-${op.replace(/[^a-z]/g, "")}`}
        >
          <Icon className="w-4 h-4 text-zinc-400 shrink-0 mt-0.5 sm:mt-0" strokeWidth={1.75} />
          <span className="flex flex-col sm:flex-row sm:items-center min-w-0 sm:gap-3">
            <code className="text-[13px] font-mono text-[#0033CC] sm:w-36 shrink-0">{example}</code>
            <span className="text-xs text-zinc-500 sm:truncate">{desc}</span>
          </span>
        </button>
      ))}
      <div className="px-2 pt-2 text-[11px] text-zinc-400">
        Combine them: <code className="font-mono">from:ralph has:attachment loan</code>
      </div>
    </div>
  );
}
